import React from 'react';
import styles from './Switch.module.css';

const Switch = ({
    id,
    checked = false,
    onChange,
    disabled = false,
    size = 'md',
    className = '',
    label,
    labelPosition = 'right',
    'aria-describedby': ariaDescribedBy
}) => {
    const handleChange = (e) => {
        if (!disabled && onChange) {
            onChange(e.target.checked);
        }
    };

    const handleKeyDown = (e) => {
        if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            if (!disabled && onChange) {
                onChange(!checked);
            }
        }
    };

    return (
        <div
            className={`${styles.switchWrapper} ${disabled ? styles.disabled : ''} ${className}`}
            role="switch"
            aria-checked={checked}
            aria-disabled={disabled}
            tabIndex={disabled ? -1 : 0}
            onKeyDown={handleKeyDown}
        >
            <input
                type="checkbox"
                id={id}
                checked={checked}
                onChange={handleChange}
                disabled={disabled}
                aria-describedby={ariaDescribedBy}
                className={styles.input}
            />
            <label
                htmlFor={id}
                className={`${styles.switchTrack} ${styles[size]}`}
                onClick={(e) => {
                    if (!disabled) {
                        e.preventDefault();
                        onChange(!checked);
                    }
                }}
            >
                <span className={styles.switchThumb} />
            </label>
            {label && (
                <label
                    htmlFor={id}
                    className={`${styles.label} ${styles[labelPosition]} ${disabled ? styles.labelDisabled : ''}`}
                >
                    {label}
                </label>
            )}
        </div>
    );
};

export default Switch;
